module.exports = __webpack_public_path__ + "img/Feature.84b28a0b.jpg";